
import React from "react"
import { Card, Container, Row, Col, Button, Form } from "react-bootstrap"

function numberOrNull(value) {
	if (value === "" || value == null) return null
	const n = Number(value)
	return Number.isFinite(n) ? n : null
}

export default class EditSubscriptionWorkOrderView extends React.Component {
	constructor(props) {
		super(props)

    props.subscription.start_date = stringToDate(props.subscription.start_date)?.toUTC()
    props.subscription.end_date = stringToDate(props.subscription.end_date)?.toUTC()
    props.subscription.cancellation_date = stringToDate(props.subscription.cancellation_date)?.toUTC()
    props.subscription.feedlot_subs.forEach((fsub) => {
      fsub.date_added = stringToDate(fsub.date_added)?.toUTC()
      fsub.date_removed = stringToDate(fsub.date_removed)?.toUTC()
    })
		this.subscription = props.subscription
    
		
		this.state = {
			work_order: props.work_order,
			submitting: false,
			response_errors: [],
      counties: [],
		}

    this.getCountyInfo = this.getCountyInfo.bind(this)
    this.getCountyInfo()

    this.itemTypes = [
      { value: "COUNT/AUDIT", label: "COUNT/AUDIT" },
      { value: "3054", label: "SOFTWARE/HARDWARE SALES" },
      { value: "6370", label: "TRAVEL EXPENSE" },
    ]

    this.billingCodes = [
      { value: "100", label: "100" },
      { value: "SUBSCRIPTION_1", label: "SUBSCRIPTION_1" },
      { value: "SUBSCRIPTION_2", label: "SUBSCRIPTION_2" },
      { value: "SUBSCRIPTION_3", label: "SUBSCRIPTION_3" },
      { value: "SUBSCRIPTION_4", label: "SUBSCRIPTION_4" },
      { value: "SUBSCRIPTION_5", label: "SUBSCRIPTION_5" },
      { value: "SUBSCRIPTION_6", label: "SUBSCRIPTION_6" },
      { value: "SUBSCRIPTION_7", label: "SUBSCRIPTION_7" },
      { value: "SUBSCRIPTION_8", label: "SUBSCRIPTION_8" },
      { value: "SUBSCRIPTION_9", label: "SUBSCRIPTION_9" },
      { value: "SUBSCRIPTION_10", label: "SUBSCRIPTION_10" },
      { value: "SUBSCRIPTION_11", label: "SUBSCRIPTION_11" },
      { value: "SUBSCRIPTION_12", label: "SUBSCRIPTION_12" }
    ]
	}

	render() {
		try {
			const wo = this.state.work_order
      const line_items = wo.subscription_line_items || []
      const counties = this.state.counties || []
			const total = this.totalPrice()

			return (
				<Card>
					<Card.Header>
						<Container fluid>
							<Row className="align-items-center">
								<Col>
									<h3 className="mb-0">Edit Subscription Work Order</h3>
								</Col>
								<Col xs="auto">
									<a className="btn btn-primary" href={Routes.admin_subscription_path(this.subscription.id)}>
										Back
									</a>
								</Col>
							</Row>
						</Container>
					</Card.Header>

					<Card.Body>
            <Container fluid>
              {/* Display Subscription Details */}
              <Row>
                <Col>
                  <h5 className="my-0">
                    <b>{this.subscription.feedlot_subs.map(f => f.feedlot_name).join(", ")}</b>
                  </h5>
                  <h6 className="mb-0">
                    <b>Name: </b>{this.subscription.name}
                  </h6>
                </Col>
              </Row>
              <Row>
                <Col xs="auto">
                  <p className="mb-1"><strong>Start Date:</strong> {new Date(this.subscription.start_date).toLocaleDateString()}</p>
                  <p className="mb-1"><strong>End Date:</strong> {new Date(this.subscription.end_date).toLocaleDateString()}</p>
                </Col>
                <Col xs="auto">
                  <p className="mb-1"><strong>Count Limit:</strong> {this.subscription.count_limit}</p>
                  <p className="mb-1"><strong>Current Count:</strong> {this.subscription.current_count}</p>
                </Col>
                <Col xs="auto">
                  <p className="mb-1"><strong>Price:</strong> {this.subscription.price}</p>
                  <p className="mb-1"><strong>Overage Rate:</strong> {this.subscription.overage_rate}</p>
                </Col>
                <Col xs="auto">
                  <p className="mb-1"><strong>Billed Overage:</strong> {this.subscription.billed_overage}</p>
                  <p className="mb-1"><strong>Unbilled Overage:</strong> {this.subscription.unbilled_overage_count}</p>
                </Col>
                <Col xs="auto">
                  <p className="mb-1"><strong>Is Micro:</strong> {this.subscription.is_micro ? 'Yes' : 'No'}</p>
                  <p className="mb-1"><strong>Location No:</strong> {this.countyFromLocationNo(this.subscription.location_no)}</p>
                  <p className="mb-1"><strong>Kham Name:</strong> {this.subscription.kham_name}</p>
                </Col>
              </Row>

              <hr />

              {/* Display Errors */}
              <Row>
                <Col xs="auto">
						      {this.renderErrors(this.state.response_errors)}
                </Col>
              </Row>
              {/* Owner Kham Name & Customer Number */}
              <Row>
                <Col xs="auto">
                  <label className="my-0"><strong>Owner Kham Name</strong></label>
                  <input
                    type="text"
                    className="form-control"
                    value={wo.owner_kham_name || ""}
                    onChange={(e) => {
                      var work_order = { ...this.state.work_order };
                      work_order.owner_kham_name = e.target.value;
                      this.setState({ work_order });
                    }}
                  />
                </Col>

                <Col xs="auto">
                  <label className="my-0"><strong>Customer Number</strong></label>
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.work_order.customer_number || ""}
                    onChange={(e) => {
                      var work_order = { ...this.state.work_order };
                      work_order.customer_number = e.target.value;
                      this.setState({ work_order });
                    }}
                  />
                </Col>
              </Row>

              <hr />

              {/* Line Items */}
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0">
                    <strong>Line Items</strong>
                  </h5>
                </Col>
                <Col xs="auto">
                  <Button variant="success" onClick={() => this.addLineItem()}>
                    Base
                    <i className="fas fa-plus ml-2" />
                  </Button>
                  <Button className="mx-2" variant="success" onClick={() => this.addOverageLineItem()}>
                    Overage
                    <i className="fas fa-plus ml-2" />
                  </Button>
                  <Button className="mx-2" variant="success" onClick={() => this.addCustomLineItem()}>
                    Custom
                    <i className="fas fa-plus ml-2" />
                  </Button>
                </Col>
              </Row>

              <hr />

              {line_items.map((line_item, idx) => (
                <React.Fragment key={idx}>
                  <Row key={idx}>

                    <Col xs="auto" className="d-flex flex-column align-items-center">
                      <label className="my-0"><strong>Overage?</strong></label>
                      <input
                        type="checkbox"
                        className="form-check-input mt-2"
                        checked={!!line_item.is_overage}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], is_overage: e.target.checked };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Billing Code</strong></label>
                      <select
                        className="form-control"
                        value={line_item.billing_code ?? ""}
                        onChange={(e) => {
                          const value = e.target.value
                          this.updateLineItemField(idx, "billing_code", value)
                        }}
                      >
                        <option value={""}></option>
                        {(() => {
                          const current = line_item.billing_code
                          const hasCurrent =
                            current != null &&
                            current !== "" &&
                            this.billingCodes.some((c) => String(c.value) === String(current))
                          if (hasCurrent) return null
                          if (current == null || current === "") return null
                          return <option value={current}>Unknown ({current})</option>
                        })()}
                        {this.billingCodes.map((c) => (
                          <option key={c.value} value={c.value}>
                            {c.label}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Description Prefix</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={20}
                        value={line_item.description_prefix || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], description_prefix: e.target.value };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Description</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={35}
                        value={line_item.description || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], description: e.target.value };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Additional Description</strong></label>
                      <input
                        type="text"
                        className="form-control"
                        maxLength={55}
                        value={line_item.add_description || ""}
                        style={{ fieldSizing: "content" }}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], add_description: e.target.value };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Item</strong></label>
                      <select
                        className="form-control"
                        value={line_item.item ?? ""}
                        onChange={(e) => {
                          const value = e.target.value
                          this.updateLineItemField(idx, "item", value)
                        }}
                      >
                        <option value={""}></option>
                        {(() => {
                          const current = line_item.item
                          const hasCurrent = current != null && current !== "" && this.itemTypes.some((t) => String(t.value) === String(current))
                          if (hasCurrent) return null
                          if (current == null || current === "") return null
                          return <option value={current}>Unknown ({current})</option>
                        })()}
                        {this.itemTypes.map((t) => (
                          <option key={t.value} value={t.value}>
                            {t.label}
                          </option>
                        ))}
                      </select>
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Location No</strong></label>
                <select
                  className="form-control"
                  value={line_item.location_no ?? ""}
                  onChange={(e) => {
                    const value = e.target.value
                    const parsed = value === "" ? null : parseInt(value, 10)
                    this.updateLineItemField(idx, "location_no", parsed)
                  }}
                >
                  <option value={""}></option>
                  {(() => {
                    const current = line_item.location_no
                    const hasCurrent = current != null && current !== "" && counties.some((c) => String(c.location_no) === String(current))
                    if (hasCurrent) return null
                    if (current == null || current === "") return null
                    return <option value={current}>Unknown ({current})</option>
                  })()}
                  {counties.map((c) => (
                    <option key={c.location_no} value={c.location_no}>
                      {c.location}
                    </option>
                  ))}
                </select>
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Unit</strong></label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={line_item.unit ?? ""}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], unit: e.target.value };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto">
                      <label className="my-0"><strong>Rate</strong></label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control"
                        value={line_item.rate ?? ""}
                        onChange={(e) => {
                          var work_order = { ...this.state.work_order };
                          var subscription_line_items = work_order.subscription_line_items.slice();
                          subscription_line_items[idx] = { ...subscription_line_items[idx], rate: e.target.value };
                          work_order.subscription_line_items = subscription_line_items;
                          this.setState({ work_order });
                        }}
                      />
                    </Col>

                    <Col xs="auto" className="d-flex flex-column align-items-end">
                      <label className="my-0"><strong>Price</strong></label>
                      <div className="form-control-plaintext">{this.lineItemPrice(line_item).toFixed(2)}</div>
                    </Col>

                  <Col xs="auto" className="d-flex flex-column align-items-center">
                    <label className="my-0"><strong>Remove</strong></label>
                    <Button variant="danger" onClick={() => this.removeLineItem(idx)}>
                      <i className="fas fa-trash" />
                    </Button>
                  </Col>

                  </Row>

                  <hr />
                </React.Fragment>
              ))}
            </Container>
					</Card.Body>

					<Card.Footer>
						{this.renderErrors(this.state.response_errors)}
						<Button variant="success" onClick={() => this.submit()} disabled={this.state.submitting}>
							Submit
						</Button>
					</Card.Footer>
				</Card>
			)
		} catch (error) {
			console.log(error)
			Sentry.captureException(error)
			return <h3 className="text-danger">Error Loading Page. Contact Developer</h3>
		}
	}

  getCountyInfo() {
    $.ajax({
      url: Routes.counties_admin_feedlots_path(),
      type: "GET",
      dataType: "json",
      success: (response) => {
        if (response?.status === "Success") {
          this.setState({ counties: response.locations || [] })
        } else {
          this.setState({ counties: [] })
        }
      },
      error: () => {
        this.setState({ counties: [] })
      },
    })
  }

  countyFromLocationNo(location_no) {
    const county = (this.state.counties || []).find((c) => String(c.location_no) === String(location_no))
    return county ? county.location : `Unknown (${location_no})`
  }

  addLineItem() {
    const work_order = { ...this.state.work_order }
    const items = (work_order.subscription_line_items || []).slice()
    items.push({
      billing_code: `SUBSCRIPTION_${this.endDateMonth()}`,
      description: `Headcount ${this.startDateYear()} Subscription`,
      description_prefix: `${this.subscription.name}`,
      add_description: `Start ${this.monthName(this.startDateMonth())},  ${this.subscription.count_limit}, overage \$${this.subscription.overage_rate}/hd, 12 months`,
      item: "COUNT/AUDIT",
      rate: Math.round((this.subscription.price / 12) * 100) / 100,
      unit: 12.0,
      location_no: this.subscription.location_no,
      is_overage: false,
    })
    work_order.subscription_line_items = items
    this.setState({ work_order })
  }

  addOverageLineItem() {
    const work_order = { ...this.state.work_order }
    const items = (work_order.subscription_line_items || []).slice()
    items.push({
      billing_code: "100",
      description: `Overage Fee ${this.monthName(this.current_month())}`,
      description_prefix: `${this.subscription.name}`,
      add_description: `Cattle counted over ${this.subscription.count_limit} head \$${this.subscription.overage_rate}/hd`,
      item: "COUNT/AUDIT",
      rate: this.subscription.overage_rate,
      unit: Math.max(this.subscription.unbilled_overage_count || 0, 0),
      location_no: this.subscription.location_no,
      is_overage: true,
    })
    work_order.subscription_line_items = items
    this.setState({ work_order })
  }

  addCustomLineItem() {
    const work_order = { ...this.state.work_order }
    const items = (work_order.subscription_line_items || []).slice()
    items.push({
      billing_code: "100",
      description: "",
      description_prefix: `${this.subscription.name}`,
      add_description: "",
      item: "COUNT/AUDIT",
      rate: 0,
      unit: 1,
      location_no: this.subscription.location_no,
      is_overage: false,
    })
    work_order.subscription_line_items = items
    this.setState({ work_order })
  }

  removeLineItem(idx) {
    const work_order = { ...this.state.work_order }
    const items = (work_order.subscription_line_items || []).slice()
    items.splice(idx, 1)
    work_order.subscription_line_items = items
    this.setState({ work_order })
  }

	updateWorkOrderField(field, value) {
		const work_order = { ...this.state.work_order }
		work_order[field] = value
		this.setState({ work_order })
	}

	updateLineItemField(idx, field, value) {
		const work_order = { ...this.state.work_order }
		const items = work_order.subscription_line_items.slice()
		items[idx] = { ...items[idx], [field]: value }
		work_order.subscription_line_items = items
		this.setState({ work_order })
	}

	lineItemPrice(li) {
		const rate = Number(li.rate || 0)
		const unit = Number(li.unit || 0)
		if (!Number.isFinite(rate) || !Number.isFinite(unit)) return 0
		return rate * unit
	}

	totalPrice() {
		return (this.state.work_order.subscription_line_items || []).reduce((sum, li) => sum + this.lineItemPrice(li), 0)
	}

	renderErrors(errors) {
		if (!errors || errors.length === 0) return null
		return errors.map((e, i) => (
			<p key={i} className="text-danger my-0">
				{e}
			</p>
		))
	}

	async submit() {
		if (this.state.submitting) return

		this.setState({ submitting: true, response_errors: [] })

		const wo = this.state.work_order
		const payload = {
      id: wo.id,
      customer_number: wo.customer_number,
			owner_kham_name: wo.owner_kham_name,
			subscription_line_items: (wo.subscription_line_items || []).map((li) => ({
				billing_code: li.billing_code,
				description: li.description,
				description_prefix: li.description_prefix,
				add_description: li.add_description,
				item: li.item,
				rate: numberOrNull(li.rate),
				unit: numberOrNull(li.unit),
				location_no: numberOrNull(li.location_no),
				is_overage: !!li.is_overage,
			})),
		}

		const path = Routes.update_work_order_admin_subscription_path(this.subscription.id)
		$.ajax({
			url: path,
			method: "POST",
			dataType: "json",
			data: { subscription_work_order: payload },
			success: (data) => {
				if (data?.status === "success") {
					window.location = Routes.admin_subscription_path(data.subscription_id || this.subscription.id)
				} else {
					this.setState({ response_errors: data?.errors || ["Request Failed"], submitting: false })
				}
			},
			error: () => {
				this.setState({ response_errors: ["Request Failed"], submitting: false })
			},
			complete: () => {
				this.setState({ submitting: false })
			},
		})
	}

  current_year() {
    return new Date().getFullYear();
  }

  startDateYear() {
    return this.subscription?.start_date?.getFullYear()
  }

  current_month() {
    return new Date().getMonth() + 1; // 1-12
  }

  startDateMonth() {
    return this.subscription?.start_date?.getMonth() + 1 // 1-12
  }

  endDateMonth() {
    return this.subscription?.end_date?.getMonth() + 1 // 1-12
  }

  monthName(monthNum) {
    if (!monthNum) return null
    const date = new Date(2000, monthNum - 1, 1) // Year and day don't matter
    return date.toLocaleString('default', { month: 'short' }) // Abbreviated month name
  }

  getCurrentMonthOfSubscription() {
    const year_difference = this.current_year() - this.startDateYear()
    const startMonth = this.startDateMonth()
    const currentMonth = this.current_month() + (year_difference * 12) - startMonth + 1
    return currentMonth > 0 ? currentMonth : 0
  } 

}

